import React from 'react';
import s from './ToolsButtons.module.css';

import IconImageEditor from '../../../../shared/ui/icons/IconImageEditor';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectImageData } from '../../../../store/selectors/projectSelectors';

const EditImageButton = () => {
    const navigate = useNavigate();
    const imageData = useSelector(selectImageData);
    const handleNavigateToImagePage = () => {
        if (imageData?.id) {
            navigate(`/image_project/${imageData.id}`);
        }
    };
    return (
        <button className={s.container} onClick={handleNavigateToImagePage}>
            <IconImageEditor width={25} height={25} />
            <p>Edit Image</p>
        </button>
    );
};

export default EditImageButton;
